import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './styles.css';
export var Link = React.memo(function (props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React.createElement("a", _extends({}, props, mergeStyles(styles['link'], className)), children);
});
Link.displayName = 'Link';